import { pathOr } from 'ramda';
import { useSportsbookStore } from '../../../../store';

export const selectEventFieldLength = (eventId, fieldPath) =>
  pathOr(0, [
    'events',
    eventId,
    ...(Array.isArray(fieldPath) ? fieldPath : [fieldPath]),
    'length'
  ]);

export const useEventFieldLength = (eventId, fieldPath) =>
  useSportsbookStore(selectEventFieldLength(eventId, fieldPath));
